<app-fechar-os 
titulo="Visto de Execução" 
[tipoAcaoOS]="2"></app-fechar-os>
